import { Dayjs } from 'dayjs';
import { Contract, ContractAssignedVessels } from '../../../types/contract';
import { ContractInsurance } from '../../../types/insurance';
import { PortSelectItem } from '../../../types/port';
import { Route } from '../../../types/route';

export interface ContractTemplateContext {
  contractId: string | null;
  contract: Contract | null;
  isContractDisabled: boolean;
  updateContextContract: (contract: Contract) => void;
  setDisplayedContractName: (name: string) => void;
  isFetching: boolean;
  error: Error | null;
  refetchContract: () => void;
  routesManagement: {
    routes: Route[];
    isLoading: boolean;
    isFetching: boolean;
    error: Error | null;
    refetch: () => void;
    addRouteToContext: (route: Route) => void;
    removeRouteFromContext: (routeId: string) => void;
  };
  insuranceManagement: {
    insurances: ContractInsurance[];
    isFetching: boolean;
    refetch: () => void;
  };
  assignedVesselsManagement: {
    assignedVessels: ContractAssignedVessels | null;
    isLoading: boolean;
    isFetching: boolean;
    error: Error | null;
    refetch: () => void;
  };
}

export interface ContractTemplateSubPageContext
  extends ContractTemplateContext {
  contractId: string;
  contract: Contract;
  error: null;
}

// Using "Omit" isntead of Pick so the replacements are clear
export type ProcessedRoute = Omit<
  Route,
  'portOfDeparture' | 'portOfArrival' | 'dateFrom' | 'dateTo' | 'departureTime'
> & {
  portOfDeparture: PortSelectItem;
  portOfArrival: PortSelectItem;
  dateFrom: Dayjs;
  dateTo: Dayjs;
  departureTime: Dayjs;
};

export enum ContractBadgeStatus {
  Compliant = 'compliant',
  Uncompliant = 'uncompliant',
  Expired = 'expired',
}
